import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock, unref as _unref, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex gap-10 flex-col max-w-7xl mx-auto justify-center mt-28 ml-[22.5%]" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "text-xl uppercase font-semibold text-[#322121] dark:text-white" }, " View Departments ", -1)
const _hoisted_3 = { class: "text-left dark:text-white" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  for: "countries",
  class: "block mb-2 text-sm font-medium text-gray-900 dark:text-white"
}, "Select category", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("option", { disabled: "" }, "Select Category", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", null, "DEPARTMENTS", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("option", null, "UNITS", -1)
const _hoisted_8 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "relative h-full w-full sm:rounded-lg mb-20" }
const _hoisted_10 = {
  key: 0,
  class: "mb-10 w-full border dark:border-gray-600 text-sm text-left text-gray-500 dark:text-gray-400"
}
const _hoisted_11 = { class: "text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-6 py-3"
}, "No", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-6 py-3"
}, "Title", -1)
const _hoisted_14 = {
  key: 0,
  scope: "col",
  class: "px-6 py-3"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-6 py-3"
}, "View", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-6 py-3"
}, "Delete", -1)
const _hoisted_17 = { class: "px-6 py-4" }
const _hoisted_18 = {
  scope: "row",
  class: "px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
}
const _hoisted_19 = {
  key: 0,
  scope: "row",
  class: "px-6 py-4 font-medium text-gray-900 whitespace-nowrap dark:text-white"
}
const _hoisted_20 = { class: "px-6 py-4" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "px-6 py-4" }
const _hoisted_23 = ["onClick"]

import { ref, watch } from 'vue';
import { Pagination } from 'flowbite-vue';
import { useRouter } from 'vue-router';
import axios from 'axios';
import { url } from '@/functions/endpoint';
import { decodeEntities } from "@/functions";
import DeleteModal from "@/components/DeleteModal.vue";
import SuccessMessage from "@/components/SuccessMessage.vue";
import ErrorMessage from "@/components/ErrorMessage.vue";
import Loader from "@/components/Loader.vue";
import EmptyState from "@/components/EmptyState.vue";
import { Posts } from '@/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'ViewDepartments',
  setup(__props) {

let count = ref(0);
const postId = ref();
const router = useRouter()
let successMessage = ref('');
let showSuccessMessage = ref(false);
const loading = ref(false);
let errorAlert = ref(false);
let errorMessage = ref('');
let emptyState = ref(false);
const perPage = ref(12);
const currentPage = ref(1);
const category = ref<string>("DEPARTMENTS")

const calculatePostNumber = (index: number) => {
  return (currentPage.value - 1) * perPage.value + index + 1;
};

const editDepartment = (departmentId: number) => {
  category.value === 'DEPARTMENTS' ? router.push({ name: 'EditDepartment', params: { id: departmentId } }) : router.push({ name: 'EditUnit', params: { id: departmentId } });
};

const deleteModal = ref(false);
const openDeleteModal = (id: number) => {
  postId.value = id;
  deleteModal.value = true;
};

const closeDeleteModal = () => {
  deleteModal.value = false;
};

const deleteDocument = async () => {
  try {
    const response = await axios.delete(
      category.value === 'DEPARTMENTS'
        ? `${url}/departments/delete/${postId.value}`
        : `${url}/unit/delete/${postId.value}`
    );

    deleteModal.value = false;
    successMessage = response.data;
    showSuccessMessage.value = true;

    const deletedIndex = allDepartments.value.findIndex((item: any) => item.id === postId.value);
    if (deletedIndex !== -1) {
      allDepartments.value.splice(deletedIndex, 1);
    }

    setTimeout(() => {
      showSuccessMessage.value = false;
    }, 2000);
  } catch (error: any) {
    deleteModal.value = false;
    errorAlert.value = true;
    errorMessage.value = error.message;

    setTimeout(() => {
      errorAlert.value = false;
    }, 2500);
  }
};


const allDepartments: any = ref([]);
const fetchNewsItems = () => {
  loading.value = true;
  emptyState.value = false;
  category.value === 'DEPARTMENTS' ? 
  axios
    .get(`${url}/departments`, {
      params: {
        page: currentPage.value,
        limit: perPage.value
      }
    })
    .then((response: any) => {
      allDepartments.value = response.data;
      count.value = response.data?.length;
    })
    .catch((error: string) => {
      console.error(error);
    })
    .finally(() => {
      loading.value = false;
    }) : axios
    .get(`${url}/unit`, {
      params: {
        page: currentPage.value,
        limit: perPage.value
      }
    })
    .then((response: any) => {
      allDepartments.value = response.data[1];
      count.value = response.data[0].totalLength;
    })
    .catch((error: string) => {
      console.error(error);
    })
    .finally(() => {
      loading.value = false;
    })
};

watch(currentPage, fetchNewsItems);
fetchNewsItems();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives(_createElementVNode("select", {
          placeholder: "Select category",
          id: "countries",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((category).value = $event)),
          onChange: fetchNewsItems,
          class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        }, _hoisted_8, 544), [
          [_vModelSelect, category.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        (!loading.value)
          ? (_openBlock(), _createElementBlock("table", _hoisted_10, [
              _createElementVNode("thead", _hoisted_11, [
                _createElementVNode("tr", null, [
                  _hoisted_12,
                  _hoisted_13,
                  (category.value === 'UNITS')
                    ? (_openBlock(), _createElementBlock("th", _hoisted_14, "Department"))
                    : _createCommentVNode("", true),
                  _hoisted_15,
                  _hoisted_16
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allDepartments.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item.id
                  }, [
                    _createElementVNode("td", _hoisted_17, _toDisplayString(calculatePostNumber(index)), 1),
                    _createElementVNode("td", _hoisted_18, _toDisplayString(category.value === "DEPARTMENTS" ? item?.name?.slice(0, 80) : item?.title?.slice(0, 80)), 1),
                    (category.value === 'UNITS')
                      ? (_openBlock(), _createElementBlock("td", _hoisted_19, _toDisplayString(item?.departmentId), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("td", _hoisted_20, [
                      _createElementVNode("button", {
                        onClick: ($event: any) => (editDepartment(item.id)),
                        class: "font-medium text-blue-600 dark:text-blue-500 hover:underline"
                      }, "Edit", 8, _hoisted_21)
                    ]),
                    _createElementVNode("td", _hoisted_22, [
                      _createElementVNode("button", {
                        onClick: ($event: any) => (openDeleteModal(item.id)),
                        class: "font-medium text-red-600 dark:text-red-500 hover:underline"
                      }, "Delete", 8, _hoisted_23)
                    ])
                  ]))
                }), 128))
              ])
            ]))
          : (_openBlock(), _createBlock(Loader, {
              key: 1,
              class: "my-52"
            })),
        _createVNode(EmptyState, { showEmptyState: _unref(emptyState) }, null, 8, ["showEmptyState"]),
        _createVNode(_unref(Pagination), {
          modelValue: currentPage.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((currentPage).value = $event)),
          "per-page": perPage.value,
          "total-items": _unref(count),
          layout: 'table'
        }, null, 8, ["modelValue", "per-page", "total-items"])
      ])
    ]),
    (deleteModal.value)
      ? (_openBlock(), _createBlock(DeleteModal, {
          key: 0,
          onDeletePost: deleteDocument,
          onCloseDeleteModal: closeDeleteModal,
          item: 'department'
        }))
      : _createCommentVNode("", true),
    _createVNode(SuccessMessage, {
      showSuccessMessage: _unref(showSuccessMessage),
      successMessage: _unref(successMessage)
    }, null, 8, ["showSuccessMessage", "successMessage"]),
    _createVNode(ErrorMessage, {
      errorAlert: _unref(errorAlert),
      errorMessage: _unref(errorMessage)
    }, null, 8, ["errorAlert", "errorMessage"])
  ], 64))
}
}

})